import React from 'react';
import { FormProvider } from 'react-hook-form';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { contentWrapBreakpoint, Paper } from '../../../../ui';
import { useUserStore } from '../../../auth/user/domain/stores/useUserStore';
import {
	getOverlapWithHeaderStyles,
	StyledHeader,
} from '../../../shared/components';
import { AccountDetailsForm } from './AccountDetailsForm';
import { useDetailsForm } from '../../../shared/account/details/hooks/useDetailsForm';
import ContentWrap from '../../../../ui/components/Layout/ContentWrap';
import themed from '../../../../ui/themer/themed';
import Responsive from '../../../../ui/utils/Responsive';

export const AccountDetailsFormContainer = observer(() => {
	const { user } = useUserStore();

	const form = useDetailsForm({
		defaultValues: user,
		requiresConsent: false,
	});

	return (
		<StyledContentWrap backgroundTheme="purple-blue">
			<ContentWrap>
				<StyledPaper>
					<FormProvider {...form}>
						<AccountDetailsForm form={form} />
					</FormProvider>
				</StyledPaper>
			</ContentWrap>
		</StyledContentWrap>
	);
});

const StyledContentWrap = styled('div')`
	width: 100%;
	margin: 0 auto;

	${StyledHeader} + style + &,
  	${StyledHeader} + & {
		${getOverlapWithHeaderStyles}
	}

	@media (${contentWrapBreakpoint}) {
		max-width: none;
		margin: 0 ${themed(({ layout }) => layout.main.margin.tablet)};
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-left: 0;
	}
`;
const StyledPaper = styled(Paper)`
	max-width: ${themed(({ layout }) => layout.main.textMaxWidth)};
`;
